import {
    ADD_SOCIAL_TEMPLATES,
    ADD_SOCIAL_TEMPLATES_FAIL,
    ADD_SOCIAL_TEMPLATES_SUCCESS,
    FETCH_ADMIN_OKR,
    FETCH_ADMIN_OKR_FAIL,
    FETCH_ADMIN_OKR_SUCCESS,
    FETCH_ALL_ENTITIES,
    FETCH_ALL_ENTITIES_FAIL,
    FETCH_ALL_ENTITIES_SUCCESS,
    FETCH_BR_SUBSCRIPTION,
    FETCH_BR_SUBSCRIPTION_FAIL,
    FETCH_BR_SUBSCRIPTION_SUCCESS,
    FETCH_MANAGE_BR_SUBSCRIPTION,
    FETCH_MANAGE_BR_SUBSCRIPTION_FAIL,
    FETCH_MANAGE_BR_SUBSCRIPTION_SUCCESS,
    FETCH_MANAGE_SUB_TYPE,
    FETCH_MANAGE_SUB_TYPE_FAIL,
    FETCH_MANAGE_SUB_TYPE_SUCCESS,
    FETCH_SOCIAL_TEMPLATES,
    FETCH_SOCIAL_TEMPLATES_FAIL,
    FETCH_SOCIAL_TEMPLATES_SUCCESS,
    SEND_SOCIAL_TEMPLATE_TEST,
    SEND_SOCIAL_TEMPLATE_TEST_FAIL,
    SEND_SOCIAL_TEMPLATE_TEST_SUCCESS,
    UPDATE_ENTITY,
    UPDATE_ENTITY_FAIL,
    UPDATE_ENTITY_NAME,
    UPDATE_ENTITY_NAME_FAIL,
    UPDATE_ENTITY_NAME_SUCCESS,
    UPDATE_ENTITY_SETTINGS,
    UPDATE_ENTITY_SETTINGS_FAIL,
    UPDATE_ENTITY_SETTINGS_SUCCESS,
    UPDATE_ENTITY_SUCCESS,
    UPDATE_PENTEST_SETTING_FOR_ENTITY,
    UPDATE_PENTEST_SETTING_FOR_ENTITY_FAIL,
    UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS,
    UPDATE_SOCIAL_TEMPLATES,
    UPDATE_SOCIAL_TEMPLATES_FAIL,
    UPDATE_SOCIAL_TEMPLATES_SUCCESS,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_FAIL,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_SUCCESS,
    VERIFY_PRIMARY_DOMAIN,
    VERIFY_PRIMARY_DOMAIN_FAIL,
    VERIFY_PRIMARY_DOMAIN_SUCCESS
} from "../constants/ActionTypes";


const INIT_STATE = {
    okr: null,
    templates: null,
    loadingTemplates: false,
    loadingTemplatesError: false,
    addingTemplateLoading: false,
    addingTemplateError: false,
    updatingTemplateLoading: false,
    updatingTemplateError: false,
    loadingAdminOKR: false,
    loadingAdminOKRError: false,
    sendingTestEmail: {},
    justSentTestEmail: {},
    errorSendingTestEmail: {},
    stripeRedirectURL: null,
    loadingStripeRedirectURL: {},
    errorStripeRedirectURL: {},
    stripeRedirectURLSubType: null,
    loadingStripeRedirectURLSubType: {},
    errorStripeRedirectURLSubType: {},
    subscriptionInfo: {},
    loadingSubscriptions: {},
    errorLoadingSubscriptions: {},
    entitiesList: null,
    loadingEntitiesList: null,
    loadingEntitiesListError: null,
    loadingVerifyPrimaryDomain: {},
    loadingVerifyPrimaryDomainError: {},
    loadingUpdateEntity: {},
    loadingUpdateEntityError: {},
    loadingUpdateEntityPenTesting: {},
    loadingUpdateEntityPenTestingError: {},
    loadingUpdateEntitySocialTesting: {},
    loadingUpdateEntitySocialTestingError: {},
    loadingUpdateEntityCycleDate: {},
    loadingUpdateEntityCycleDateError: {},
    loadingUpdateEntitySettings: {},
    loadingUpdateEntitySettingsError: {},
};

const admin = (state = INIT_STATE, action) => {
    switch(action.type){

        /***********************************
         * FETCH ADMIN OKR DATA
         ***********************************/

        case FETCH_ADMIN_OKR: {
            return {
                ...state,
                loadingAdminOKR: true,
                loadingAdminOKRError: false
            }
        }

        case FETCH_ADMIN_OKR_SUCCESS: {
            // console.log("FETCH_USERS_SUCCESS with payload data:", action.payload)

            const newOKRData = action.payload.inboundData;
            return {
                ...state,
                okr: {
                    ...state.okr,
                    ...newOKRData,
                },
                loadingAdminOKR: false,
                loadingAdminOKRError: false
            }
        }


        case FETCH_ADMIN_OKR_FAIL: {
            return {
                ...state,
                loadingAdminOKR: false,
                loadingAdminOKRError: true
            }
        }

        /***********************************
         * FETCH SOCIAL TEMPLATES
         ***********************************/

        case FETCH_SOCIAL_TEMPLATES: {
            return{
                ...state,
                loadingTemplates: true,
                loadingTemplatesError: false,
            }
        }

        case FETCH_SOCIAL_TEMPLATES_SUCCESS: {

            const newTemplatesData = action.payload.inboundData;

            return{
                ...state,
                templates: {
                    ...state.templates,
                    ...newTemplatesData,
                },
                loadingTemplates: false,
                loadingTemplatesError: false,

            }
        }

        case FETCH_SOCIAL_TEMPLATES_FAIL: {
            return{
                ...state,
                loadingTemplates: false,
                loadingTemplatesError: true,
            }
        }

        /***********************************
         * ADD SOCIAL TEMPLATES
         ***********************************/

        case ADD_SOCIAL_TEMPLATES: {
            return{
                ...state,
                addingTemplateLoading: true,
                addingTemplateError: false,
            }
        }

        case ADD_SOCIAL_TEMPLATES_SUCCESS: {

            const newTemplateData = action.payload.inboundData;

            return{
                ...state,
                templates: {
                    ...state.templates,
                    templates: {
                        ...state.templates.templates,
                        [newTemplateData.id] : {
                            ...newTemplateData,
                        }
                    }
                },
                addingTemplateLoading: false,
                addingTemplateError: false,

            }
        }

        case ADD_SOCIAL_TEMPLATES_FAIL: {
            return{
                ...state,
                addingTemplateLoading: false,
                addingTemplateError: true,
            }
        }

        /***********************************
         * UPDATE SOCIAL TEMPLATES
         ***********************************/

        case UPDATE_SOCIAL_TEMPLATES: {
            return{
                ...state,
                updatingTemplateLoading: true,
                updatingTemplateError: false,
            }
        }

        case UPDATE_SOCIAL_TEMPLATES_SUCCESS: {

            const newTemplateData = action.payload.inboundData;

            return{
                ...state,
                templates: {
                    ...state.templates,
                    templates: {
                        ...state.templates.templates,
                        [newTemplateData.id] : {
                            ...newTemplateData,
                        }
                    }
                },
                updatingTemplateLoading: false,
                updatingTemplateError: false,

            }
        }

        case UPDATE_SOCIAL_TEMPLATES_FAIL: {
            return{
                ...state,
                updatingTemplateLoading: false,
                updatingTemplateError: true,
            }
        }

        /***********************************
         * UPDATE SOCIAL TEMPLATES
         ***********************************/
        case SEND_SOCIAL_TEMPLATE_TEST: {

            const templateId = action.payload.templateId

            return{
                ...state,
                sendingTestEmail: {
                    ...state.sendingTestEmail,
                    [templateId]: true
                },
                justSentTestEmail: {
                    ...state.justSentTestEmail,
                    [templateId]: false
                },
                errorSendingTestEmail:{
                    ...state.errorSendingTestEmail,
                    [templateId]: false
                },
            }
        }

        case SEND_SOCIAL_TEMPLATE_TEST_SUCCESS: {

            const templateId = action.payload.templateId

            return{
                ...state,
                sendingTestEmail: {
                    ...state.sendingTestEmail,
                    [templateId]: false
                },
                justSentTestEmail: {
                    ...state.justSentTestEmail,
                    [templateId]: true
                },
                errorSendingTestEmail:{
                    ...state.errorSendingTestEmail,
                    [templateId]: false
                },
            }
        }

        case SEND_SOCIAL_TEMPLATE_TEST_FAIL: {

            const templateId = action.payload.templateId

            return{
                ...state,
                sendingTestEmail: {
                    ...state.sendingTestEmail,
                    [templateId]: false
                },
                justSentTestEmail: {
                    ...state.justSentTestEmail,
                    [templateId]: false
                },
                errorSendingTestEmail:{
                    ...state.errorSendingTestEmail,
                    [templateId]: true
                },
            }
        }
        /***********************************
     * FETCH_SUBSCRIPTION
     ***********************************/
//MOVED FROM CUSTOMER
        case FETCH_BR_SUBSCRIPTION: {
            const customerId = action.payload.customerId;

            return{
                ...state,
                loadingSubscriptions: {
                    ...state.loadingSubscriptions,
                    [customerId]: true,
                },
                errorLoadingSubscriptions: {
                    ...state.errorLoadingSubscriptions,
                    [customerId]: false,
                },
            }
        }

        case FETCH_BR_SUBSCRIPTION_SUCCESS: {

            const customerId = action.payload.customerId;
            const newSubscriptionsObj = action.payload.inboundData && action.payload.inboundData.subscriptions;

            console.log("FETCH_BR_SUBSCRIPITON_SUCCESS, state:", state, "newSubObj", newSubscriptionsObj)
            return{
                ...state,
                subscriptionInfo: {
                    ...state.subscriptionInfo,
                    [customerId]: newSubscriptionsObj
                },
                loadingSubscriptions: {
                    ...state.loadingSubscriptions,
                    [customerId]: false,
                },
                errorLoadingSubscriptions: {
                    ...state.errorLoadingSubscriptions,
                    [customerId]: false,
                },
            }
        }

        case FETCH_BR_SUBSCRIPTION_FAIL: {
            const customerId = action.payload.customerId;

            return{
                ...state,
                loadingSubscriptions: {
                    ...state.loadingSubscriptions,
                    [customerId]: false,
                },
                errorLoadingSubscriptions: {
                    ...state.errorLoadingSubscriptions,
                    [customerId]: true,
                },
            };
        }
        /***********************************
         * FETCH SELF MANAGED SUBSCRIPTION -- get url for redirect
         ***********************************/


        case FETCH_MANAGE_BR_SUBSCRIPTION: {

            const customerId = action.payload.customerId;

            return{
                ...state,
                loadingStripeRedirectURL: {
                    ...state.loadingStripeRedirectURL,
                    [customerId]: true,
                },
                errorStripeRedirectURL: {
                    ...state.errorStripeRedirectURL,
                    [customerId]: false,
                },
            }
        }

        case FETCH_MANAGE_BR_SUBSCRIPTION_SUCCESS: {
            const customerId = action.payload.customerId;

            const redirectURL = action.payload.inboundData && action.payload.inboundData.url;

            return{
                ...state,
                stripeRedirectURL: redirectURL,
                loadingStripeRedirectURL: {
                    ...state.loadingStripeRedirectURL,
                    [customerId]: false,
                },
                errorStripeRedirectURL: {
                    ...state.errorStripeRedirectURL,
                    [customerId]: false,
                },
            }
        }

        case FETCH_MANAGE_BR_SUBSCRIPTION_FAIL: {
            const customerId = action.payload.customerId;

            return{
                ...state,
                loadingStripeRedirectURL: {
                    ...state.loadingStripeRedirectURL,
                    [customerId]: false,
                },
                errorStripeRedirectURL: {
                    ...state.errorStripeRedirectURL,
                    [customerId]: true,
                },
            }
        }

        /***********************************
         * FETCH SELF MANAGED SUBSCRIPTION for specific type
         ***********************************/


        case FETCH_MANAGE_SUB_TYPE: {
            const customerId = action.payload.customerId;
            return{
                ...state,
                loadingStripeRedirectURLSubType: {
                    ...state.loadingStripeRedirectURLSubType,
                    [customerId]: true,
                },
                errorStripeRedirectURLSubType: {
                    ...state.errorStripeRedirectURLSubType,
                    [customerId]: false,
                },
            }
        }

        case FETCH_MANAGE_SUB_TYPE_SUCCESS: {

            const redirectURL = action.payload.inboundData && action.payload.inboundData.url;
            const customerId = action.payload.customerId;
            return{
                ...state,
                stripeRedirectURLSubType: redirectURL,
                loadingStripeRedirectURLSubType: {
                    ...state.loadingStripeRedirectURLSubType,
                    [customerId]: false,
                },
                errorStripeRedirectURLSubType: {
                    ...state.errorStripeRedirectURLSubType,
                    [customerId]: false,
                },
            }
        }

        case FETCH_MANAGE_SUB_TYPE_FAIL: {
            const customerId = action.payload.customerId;
            return{
                ...state,
                loadingStripeRedirectURLSubType: {
                    ...state.loadingStripeRedirectURLSubType,
                    [customerId]: false,
                },
                errorStripeRedirectURLSubType: {
                    ...state.errorStripeRedirectURLSubType,
                    [customerId]: true,
                },
            }
        }

        /***********************************
         * FETCH ALL ENTITIES
         ***********************************/


        case FETCH_ALL_ENTITIES: {

            const pageNumberRequested = action.payload.pageNumber;

            return{
                ...state,
                loadingEntitiesList: {
                    page: pageNumberRequested,
                },
                loadingEntitiesListError: false,
            }
        }

        case FETCH_ALL_ENTITIES_SUCCESS: {

            const pageNumberRequested = action.payload.pageNumber;
            const newEntitiesArray = action.payload.inboundData.entities;
            const totalPages = action.payload.inboundData.meta.pages;
            const existingEntitiesArray = state && state.entitiesList ? state.entitiesList : [];


            const combinedEntitiesArray = existingEntitiesArray.concat(newEntitiesArray);

            const loadingEntitiesObject = pageNumberRequested !== totalPages
                ? {page: pageNumberRequested,
                    nextPageRequest: pageNumberRequested + 1,
                total: totalPages}
                : false;

            console.log("fETCH_ALL_ENTITIES_SUCCESS< loading page", pageNumberRequested, "next to load", pageNumberRequested + 1, "existingEntitiesArray", existingEntitiesArray, "newEntitiesArray", newEntitiesArray, "loadingEntitiesObject to be set", loadingEntitiesObject)

            return{
                ...state,
                loadingEntitiesList: loadingEntitiesObject,
                loadingEntitiesListError: false,
                entitiesList: combinedEntitiesArray,

            }
        }

        case FETCH_ALL_ENTITIES_FAIL: {
            const pageNumberRequested = action.payload.pageNumber;

            console.log('FETCH_ALL_ENTITIES_FAIL, on page', pageNumberRequested);

            return{
                ...state,
                loadingEntitiesList: {
                    ...state.loadingEntitiesList,
                    page: pageNumberRequested,
                    nextPageRequest: pageNumberRequested,
                },
                loadingEntitiesListError: true,

            }
        }

        /***********************************
         * Verify Primary Domain for a customer
         ***********************************/

        case VERIFY_PRIMARY_DOMAIN: {
            const entityId = action.payload.entityId;
            const newStatus = action.payload.newStatus

            return {
                ...state,
                loadingVerifyPrimaryDomain: {
                    ...state.loadingVerifyPrimaryDomain,
                    [entityId]: true,
                },
                loadingVerifyPrimaryDomainError: {
                    ...state.loadingVerifyPrimaryDomainError,
                    [entityId]: false,
                }
            }
        }

        case VERIFY_PRIMARY_DOMAIN_SUCCESS: {
            const entityId = action.payload.entityId;
            const domainId = action.payload.domainId;
            const newStatus = action.payload.newStatus;

            console.log("VERIFY_PRIMARY_DOMAIN_SUCCESS, data looks like: setting verified to ",newStatus ,"inbound", action.payload.inboundData, "entityId", entityId, "domainId", domainId)

            const entityIndex = state
                && state.entitiesList
                && state.entitiesList.findIndex((x)=> x.id === entityId);

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId)

            const domainToUpdate = entityToUpdate
            && entityToUpdate.domains
            && Object.values(entityToUpdate.domains)
                    .find((x)=> x.is_primary);

            domainToUpdate.verification.verified = newStatus;

            // const updatedArray = state
            // && state.entitiesList
            // && state.entitiesList[entityIndex]
            // && state.entitiesList[entityIndex].domains
            // && state.entitiesList[entityIndex].domains[domainToUpdate]


            return {
                ...state,
                loadingVerifyPrimaryDomain: {
                    ...state.loadingVerifyPrimaryDomain,
                    [entityId]: false,
                },
                loadingVerifyPrimaryDomainError: {
                    ...state.loadingVerifyPrimaryDomainError,
                    [entityId]: false,
                },
                // entitiesList:
            }
        }

        case VERIFY_PRIMARY_DOMAIN_FAIL: {
            const entityId = action.payload.entityId;
            const customerId = action.payload.customerId;
            const newStatus = action.payload.newStatus;
            const domainId = action.payload.domainId

            console.log("VERIFY_PRIMARY_DOMAIN_SUCCESS, data looks like: Attempted to set verified to ",newStatus ,"inbound", action.payload.inboundData, "entityId", entityId, "customerId", customerId, "domainId", domainId)


            return {
                ...state,
                loadingVerifyPrimaryDomain: {
                    ...state.loadingVerifyPrimaryDomain,
                    [entityId]: false,
                },
                loadingVerifyPrimaryDomainError: {
                    ...state.loadingVerifyPrimaryDomainError,
                    [entityId]: true,
                }
            }
        }


        /***********************************
         * Update for an entity
         ***********************************/

        case UPDATE_ENTITY: {
            const entityId = action.payload.entityId;
            const property = action.payload.property;
            const updatedValue = action.payload.updatedValue;

            return {
                ...state,
                loadingUpdateEntity: {
                    ...state.loadingUpdateEntity,
                    [entityId]: {
                        ...state.loadingUpdateEntity[entityId],
                        [property]: true
                    },
                },
                loadingUpdateEntityError: {
                    ...state.loadingUpdateEntityError,
                    [entityId]: {
                        ...state.loadingUpdateEntityError[entityId],
                        [property]: false
                    },
                }
            }
        }

        case UPDATE_ENTITY_SUCCESS : {

            const entityId = action.payload.entityId;
            const property = action.payload.property;
            const updatedValue = action.payload.updatedValue;

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId)

            entityToUpdate[property] = updatedValue;

            console.log(" UPDATE_ENTITY__SUCCESSS. Data is, entity Id", entityId, "updatedName", updatedValue, "inboundData", action.payload.inboundData, "state is", state);

            return{
                ...state,
                loadingUpdateEntity: {
                    ...state.loadingUpdateEntity,
                    [entityId]: false
                },
                loadingUpdateEntityError: {
                    ...state.loadingUpdateEntityError,
                    [entityId]: false
                },
            }
        }

        case UPDATE_ENTITY_FAIL: {
            const entityId = action.payload.entityId;
            const property = action.payload.property;
            const updatedValue = action.payload.updatedValue;

            console.log(" UPDATE_ENTITY_FAIL. Data is, entity Id", entityId, "updatedName", updatedValue, "inboundData", action.payload.inboundData);


            return {
                ...state,
                loadingUpdateEntity: {
                    ...state.loadingUpdateEntity,
                    [entityId]: false
                },
                loadingUpdateEntityError: {
                    ...state.loadingUpdateEntityError,
                    [entityId]: {
                        ...state.loadingUpdateEntityError[entityId],
                        [property]: true
                    },
                }
            }
        }

        /***********************************
         * Update pentesting status for an entity
         ***********************************/

        case UPDATE_PENTEST_SETTING_FOR_ENTITY: {
            const entityId = action.payload.entityId;

            return{
                ...state,
                loadingUpdateEntityPenTesting: {
                    [entityId]: true,
                },
                loadingUpdateEntityPenTestingError: {
                    [entityId]: false,
                },
            }
        }

        case UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS: {
            const entityId = action.payload.entityId;
            const newStatus =action.payload.newStatus;
            const inboundData = action.payload.inboundData;

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId);

            entityToUpdate.settings.active_testing_authorized = newStatus;

            console.log("UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS, entityTOUPDATE", entityToUpdate, "newStatus", newStatus, "inboundData", inboundData);

            return{
                ...state,
                loadingUpdateEntityPenTesting: {
                    [entityId]: false,
                },
                loadingUpdateEntityPenTestingError: {
                    [entityId]: false,
                },
            }
        }

        case UPDATE_PENTEST_SETTING_FOR_ENTITY_FAIL: {
            const entityId = action.payload.entityId;
            const newStatus =action.payload.newStatus;
            const inboundData = action.payload.inboundData;

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId);

            // entityToUpdate.settings.active_attacks_authorized = true;

            console.log("UPDATE_PENTEST_SETTING_FOR_ENTITY_Fail, entityTOUPDATE", entityToUpdate, "newStatus", newStatus, "inboundData", inboundData);

            return{
                ...state,
                loadingUpdateEntityPenTesting: {
                    [entityId]: false,
                },
                loadingUpdateEntityPenTestingError: {
                    [entityId]: true,
                },
            }
        }

        /***********************************
         * Update social testing status for an entity
         ***********************************/

        case UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY: {
            const entityId = action.payload.entityId;

            return{
                ...state,
                loadingUpdateEntitySocialTesting: {
                    [entityId]: true,
                },
                loadingUpdateEntitySocialTestingError: {
                    [entityId]: false,
                },
            }
        }

        case UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_SUCCESS: {
            const entityId = action.payload.entityId;
            const newStatus =action.payload.newStatus;
            const inboundData = action.payload.inboundData;

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId);

            entityToUpdate.settings = inboundData;

            console.log("UPDATE_SOCIAL_SETTING_FOR_ENTITY_SUCCESS, entityTOUPDATE", entityToUpdate, "newStatus", newStatus, "inboundData", inboundData);

            return{
                ...state,
                loadingUpdateEntitySocialTesting: {
                    [entityId]: false,
                },
                loadingUpdateEntitySocialTestingError: {
                    [entityId]: false,
                },
            }
        }

        case UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_FAIL: {
            const entityId = action.payload.entityId;
            const newStatus =action.payload.newStatus;
            const inboundData = action.payload.inboundData;

            const entityToUpdate = state
                && state.entitiesList
                && state.entitiesList.find((x)=> x.id === entityId);

            // entityToUpdate.settings.active_attacks_authorized = true;

            console.log("UPDATE_SOCIAL_TESTING_SETTING_FOR_ENTITY_Fail, entityTOUPDATE", entityToUpdate, "newStatus", newStatus, "inboundData", inboundData);

            return{
                ...state,
                loadingUpdateEntitySocialTesting: {
                    [entityId]: false,
                },
                loadingUpdateEntitySocialTestingError: {
                    [entityId]: true,
                },
            }
        }

    /***********************************
     * Update settings for an entity
     ***********************************/

case UPDATE_ENTITY_SETTINGS: {
        const entityId = action.payload.entityId;
        const property = action.payload.property;
        const updatedValue = action.payload.updatedValue;

        return {
            ...state,
            loadingUpdateEntitySettings: {
                ...state.loadingUpdateEntitySettings,
                [entityId]: {
                    ...state.loadingUpdateEntitySettings[entityId],
                    [property]: true
                },
            },
            loadingUpdateEntitySettingsError: {
                ...state.loadingUpdateEntitySettingsError,
                [entityId]: {
                    ...state.loadingUpdateEntitySettingsError[entityId],
                    [property]: false
                },
            }
        }
    }

case UPDATE_ENTITY_SETTINGS_SUCCESS : {

        const entityId = action.payload.entityId;
        const property = action.payload.property;
        const updatedValue = action.payload.updatedValue;

        const entityToUpdate = state
            && state.entitiesList
            && state.entitiesList.find((x)=> x.id === entityId)

        entityToUpdate.settings[property] = updatedValue;

    console.log(" UPDATE_ENTITY__SETTINGS_SUCCESSS. Data is, entity Id", entityId, "updatedName", updatedValue, "inboundData", action.payload.inboundData, "state is", state);



    return{
            ...state,
            loadingUpdateEntitySettings: {
                ...state.loadingUpdateEntitySettings,
                [entityId]: false
            },
            loadingUpdateEntitySettingsError: {
                ...state.loadingUpdateEntitySettingsError,
                [entityId]: false,
            }
        }
    }

case UPDATE_ENTITY_SETTINGS_FAIL: {
        const entityId = action.payload.entityId;
        const property = action.payload.property;
        const updatedValue = action.payload.updatedValue;

        console.log(" UPDATE_ENTITY__SETTINGS_FAIL. Data is, entity Id", entityId, "updatedName", updatedValue, "inboundData", action.payload.inboundData);


        return {
            ...state,
            loadingUpdateEntitySettings: {
                ...state.loadingUpdateEntitySettings,
                [entityId]: false,
            },
            loadingUpdateEntitySettingsError: {
                ...state.loadingUpdateEntitySettingsError,
                [entityId]: {
                    ...state.loadingUpdateEntitySettingsError[entityId],
                    [property]: true
                },
            }
        }
    }

        default:
            return state;
    }
};

export default admin;